import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Research = ({ data }) => {
  const [blogId, setBlogId] = useState(0);

  useEffect(() => {
    setBlogId(data.id);
  });
  return (
    <div className="research-component">
      <img className="" src={data.img} alt="Scholar" width="100%" />
      <h4>{data.researchTitle}</h4>
      <div>
        <Link
          to="/main-research"
          state={{ blog_id: blogId }}
          className="read-more"
        >
          Read more <i class="icofont-rounded-right"></i>
        </Link>
      </div>
    </div>
  );
};
